import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

import { User } from '../../../models/User'

import { DELTA_TRIAL_FEATURES } from '../../Plan/DeltaTrial/DeltaTrialFeatures'
import { Upsell } from '../../Plan/DeltaTrial/Upsell/Upsell'

import { MeetingPrepDocumentsInitialization } from '../Initialization/MeetingPrepDocumentsInitialization'
import { useDocuments } from '../DocumentUpload/hooks'

import { DocumentFilters } from './DocumentFilters'
import { DocumentGroups } from './DocumentGroups'

import './Documents.scss'

interface MeetingPrepDocumentsProps {
  clients: User[]
}

export const MeetingPrepDocuments: React.FC<MeetingPrepDocumentsProps> = ({ clients }) => {
  const { isFetching: quotasFetching, hasQuota, quotaSuccess } = useZocksQuota()

  if (!quotaSuccess && quotasFetching) {
    return null
  }

  const documentSummaryEnabled = hasQuota('ai.documentSummaryAgent.value')

  if (!documentSummaryEnabled) {
    return <Upsell feature={DELTA_TRIAL_FEATURES['processDocument']} />
  }

  return (
    <>
      <MeetingPrepDocumentsInitialization clients={clients} />
      <MeetingPrepDocumentsContent />
    </>
  )
}

const MeetingPrepDocumentsContent = () => {
  const { documentsResponse, groupedDocuments, isLoading, accountHasZDRPolicy } = useDocuments()

  return (
    <div className='d-flex flex-column zocks-gap-1.5'>
      <DocumentFilters hideContactSelector={true} />
      <DocumentGroups
        isLoading={isLoading}
        groups={groupedDocuments}
        totalElements={documentsResponse?.page.totalElements ?? 0}
        accountHasZDRPolicy={accountHasZDRPolicy}
      />
    </div>
  )
}
